module.exports = __webpack_public_path__ + "img/Matrix.df425d5e.svg";